import styled from "@emotion/styled"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableContainer from "@mui/material/TableContainer"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import { TableRowDto } from "api"
import colors from "theme/colors"

type TableDataProps = {
  header: TableRowDto
  // rows: {
  //   product: string
  //   priceOne: string
  //   priceTwo: string
  //   date: string
  //   dateTwo: string
  // }[]
  rows: TableRowDto[]
  index: number
  title?: string
}

const StyledTableCell = styled(TableCell)`
  min-width: 100px;
  width: 200px;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  ${(props) => props.theme.breakpoints.down("sm")} {
    padding-left: 0px;
    padding-right: 0px;
    padding: 16px;
  }
  ${(props) => props.theme.breakpoints.up("md")} {
    font-size: 12px;
    line-height: 18px;
    padding: 8px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    font-size: 16px;
    line-height: 24px;
    padding: 16px;
  }
`
const StyledRowCell = styled(TableCell)<{ index?: number }>`
  color: ${(props) => (props.index === 0 ? colors.blue : "black")};
`

const StyledTableRow = styled(TableRow)`
  td,
  th {
    font-size: 18px;
    font-weight: 400;

    ${(props) => props.theme.breakpoints.down("sm")} {
      padding-left: 0px;
    }
    ${(props) => props.theme.breakpoints.up("md")} {
      padding-left: 8px;
    }
    ${(props) => props.theme.breakpoints.up("lg")} {
      padding-left: 16px;
    }
  }
`

function TableData({ header, rows, index, title }: TableDataProps) {
  const { Columns: headerColumns } = header
  return (
    <TableContainer>
      <Table id={`table${index}`} aria-label={title} sx={{ width: "70%" }}>
        <TableHead>
          <TableRow>
            {headerColumns.map((item, i) => (
              <StyledTableCell key={i} variant="head">
                {item}
              </StyledTableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, i) => {
            const { Columns } = row
            return (
              <StyledTableRow
                key={i}
                sx={{ "&:last-child td, &:last-child td": { border: 0 } }}
              >
                {Columns.map((el, id) => (
                  <StyledRowCell component="td" scope="row" key={el} index={id}>
                    {el}
                  </StyledRowCell>
                ))}
              </StyledTableRow>
            )
          })}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
export default TableData
